import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import Sponsors from '../components/home/Sponsors';
import Hero from '../components/home/Hero';
import Ticker from '../components/Ticker';
import ChampionsStrip from '../components/home/ChampionsStrip';
import CountdownStrip from '../components/home/CountdownStrip';
import Featured from '../components/home/Featured';
import Matches from '../components/home/Matches';
import SeasonRecap from '../components/home/SeasonRecap';
import Features from '../components/home/Features';
import HowItWorks from '../components/home/HowItWorks';
import Screenshots from '../components/home/Screenshots';
import DownloadCTA from '../components/home/DownloadCTA';
import Faq from '../components/home/Faq';
import Contact from '../components/home/Contact';

export default function Home() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.settings().then(setSettings).catch(() => setSettings({}));
  }, []);

  return (
    <main data-testid="home-page">
      <Hero settings={settings} />
      <Ticker />
      <ChampionsStrip />
      <CountdownStrip />
      <Featured />
      <Matches />
      <SeasonRecap />
      <Sponsors />
      <Features />
      <HowItWorks />
      <Screenshots />
      <DownloadCTA settings={settings} />
      <Faq />
      <Contact settings={settings} />
    </main>
  );
}
